import styles from './styles.module.scss';
const { select_wrapper, select_label, select_input } = styles;

type OptionType = {
  label: string;
  value?: string; // fallback to label if value not provided
};

type Props = {
  label: string;
  name?: string;
  options: OptionType[];
  register: ReturnType<typeof import('react-hook-form').useForm>['register'];
  required?: boolean;
};

const SelectDropdown = ({ label, name, options, register, required = false }: Props) => {
  return (
    <div className={select_wrapper}>
      {label && (
        <label className={select_label} htmlFor={name || label}>
          {label}
        </label>
      )}
      <select
        className={select_input}
        id={name || label}
        required={required}
        {...register(name || label)}
        defaultValue=""
      >
        <option value="" disabled>
          Please select an option
        </option>
        {options.map((option, idx) => {
          const value = option.value ?? option.label;
          return (
            <option key={idx} value={value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SelectDropdown;
